import React from 'react';
import { Title } from '../../components/title';
import { createCn } from 'bem-react-classname';
import './style.css';
import { useTranslation } from 'react-i18next';

const cn = createCn('faq');

const faq = {
    'en': [
        {
            title: 'How to apply for the competition?',
            description: 'You have to download the Rules&amp;Regulations file where you can find all the information about\n' +
                '                    necessary documents, application fee and deadlines. After that you need to download and fill the\n' +
                '                    application form. Send your Application Form in PDF/WORD format together with other documents to <a\n' +
                '                        href="mailto:polerevolutionitaly@gmail.com">polerevolutionitaly@gmail.com</a>.'
        },
        {
            title: 'Do we accept the picture of the application form filled by hand?',
            description: 'No'
        },
        {
            title: 'How much is the application fee?',
            description: '<ul>\n' +
                '                    <li>Single categories - 95 euros;</li>\n' +
                '                    <li>Double/group categories - 190 euros (95 euros/person);</li>\n' +
                '                    <li>Double+single category - 175 euro;</li>\n' +
                '                    <li>Parapole - free.\n</li>\n' +
                '                </ul>\n' +
                '\n' +
                '                <p>For the athletes who want to participate in more than one category there is a discount of 10%.</p>'
        },
        {
            title: 'Which is the DEADLINE for the application?',
            description: '4 october 2026 / 4 october 2026'
        },
        {
            title: 'Who will be qualified for the World Pole Art POSA Championship?',
            description: 'Only the winners (1st, 2nd and 3rd places) of AMATEURS and ELITE categories'
        },
        {
            title: 'Is it possible to qualify for the World Pole Art if I’m from another country?',
            description: 'Yes, it is possible! But before you have to check with your national POSA Federation if there is a\n' +
                '                    national qualification championship in your country. The countries which CAN’T be qualified in our\n' +
                '                    championship: France (only Elite categories), Hungary, USA, Greece, South Korea, Norway. The athlete\n' +
                '                    with the highest score for their country will qualify to the PSWC and the athlete with the second\n' +
                '                    and third highest score for their country will also receive a place at the PSWC.'
        },
        {
            title: 'Does my coach have to be subscribed for the competition?',
            description: 'Each coach must have a pass coach which has the cost of 25 euros. The confirmation of the payment has to be sent together with the subscription form till 4th of October.'
        },
        {
            title: 'When is the deadline for the music?',
            description: 'The music/video has to be sent in MP3/MP4 format by the 10th of October, named as <strong>SURNAME_NAME_CATEGORY</strong>, to: <a href="mailto:polerevolutionitaly@gmail.com">polerevolutionitaly@gmail.com</a>.<br><br>All athletes who do not respect this deadline will immediately receive a penalty of <strong>-3 points</strong>!<br><br>Where can I get more information about POSA rules &amp; regulations?<br><a href="https://www.posaworld.org/documents/" target="_blank" rel="noopener noreferrer">https://www.posaworld.org/documents/</a>'
        },
        {
            title: 'Where can I get more information about POSA rules&amp;regulations?',
            description: '<a href={ pdfUrl } target={ \"_blank\" }>2026 POSA Rules Regulations</a>'
        }
    ],
    'it': [
        {
            title: 'Come posso iscrivermi alla competizione?',
            description: 'Devi scaricare il file del Regolamento dove troverai tutte le informazioni circa i documenti necessari, i costi di iscrizione e le deadlines. Fatto ciò dovrai scaricare e compilare il modulo di iscrizione. Invia il tuo Modulo di iscrizione esclusivamente in formato PDF/WORD insieme a tutti i documenti richiesti all\'indirizzo <a' +
                ' href="mailto:polerevolutionitaly@gmail.com">polerevolutionitaly@gmail.com</a>.'
        },
        {
            title: 'Accettate foto del modulo di iscrizione compilato a mano?',
            description: 'NO'
        },
        {
            title: 'Quali sono i costi di iscrizione?',
            description: '  <ul><li>Singoli: 95 euro;</li>\n' +
                '  <li>Double/Gruppi: 190 euro (95 euro a persona);</li>\n' +
                '  <li>Double + Singolo: 175 euro;</li>\n' +
                '  <li>Parapole: gratuito</li>\n' +
                '</ul>' +
                '  <p>Per le/gli atlete/i che decidano di partecipare in più di una categoria è previsto uno sconto del' +
                ' 10% sul costo totale.</p>\n'
        },
        {
            title: 'Qual è il TERMINE ULTIMO entro cui è possibile iscriversi?',
            description: '4 ottobre 2026'
        },
        {
            title: 'Chi ha accesso alla qualifica diretta al World Pole Art POSA Championship?',
            description: 'Unicamente i vincitori (1°, 2° e 3° posto) delle categorie AMATORI e ELITE'
        },
        {
            title: 'Posso qualificarmi al World Pole Art se vengo da un Paese estero?',
            description: 'Si, è possibile! Ma prima di iscriverti devi verificare con la  tua Federazione nazionale POSA Federation se nel tuo Paese si svolga un campionato nazionale valevole per la qualifica. I Paesi i cui atleti NON possono qualificarsi nel nostro Campionato al momento sono: Francia (solo per la categoria Elite), Ungheria, USA, Grecia, Sud Corea, Norvegia. Le/gli atlet* che ottengono il miglior piazzamento (primo, secondo e terzo miglior punteggio) nel proprio Paese, anche se non sul podio, si qualificano di diritto al  PSWC.'
        },
        {
            title: 'La/il mi* coach deve registrarsi alla competizione?',
            description: 'Il pass coach ha un costo di 25€. La conferma del pagamento dovrà essere inviata insieme al modulo di iscrizione entro il 4 ottobre.'
        },
        {
            title: 'Qual è il TERMINE ULTIMO entro cui inviare la musica?',
            description: 'La musica deve essere inviata in formato MP3 entro e non oltre il 4 ottobre, il file deve essere rinominato con indicazione di nome, cognome e categoria dell’atleta (es. <strong>MARIA_ROSSI_AMATORI 18-39</strong>) al seguente indirizzo: <a href="mailto:polerevolutionitaly@gmail.com">polerevolutionitaly@gmail.com</a>.<br><br>A tutte/i le/gli atlete/i che non rispetteranno il suddetto termine verrà immediatamente comminata una penalità di <strong>-3 punti</strong>!<br><br>Dove posso trovare maggiori informazioni circa il regolamento POSA?<br><a href="https://www.posaworld.org/documents/" target="_blank" rel="noopener noreferrer">https://www.posaworld.org/documents/</a>'


        //     The music/video has to be sent in MP3/MP4 format till 1st of October named like
            // SURNAME_NAME_CATEGORY to: polerevolutionitaly@gmail.com. All athletes who
            // will not respect this deadline will immediately get the penalty of -3 points!
        },
        {
            title: 'Dove posso trovare maggiori informazioni circa il regolamento POSA?',
            description: '<a href={ pdfUrl } target={ \"_blank\" }>2026 POSA Rules Regulations</a>'
        }
    ]
}

export const Faq = () => {
    const { i18n } = useTranslation();
    const pdfUrl = i18n.language === 'en' ? './pdf/ENG_Rules.pdf' : './pdf/IT_Rules.pdf';
    const curFaq = faq[i18n.language === 'en' ? 'en' : 'it'];

    function createMarkup(string: any) {
        return { __html: string };
    }

    return (
        <div className={ cn() }>
            <Title title={ 'FAQ' }/>
            <div className={ cn('content') }>
                { curFaq.map((item: any) => {
                    return <>
                        <h3 dangerouslySetInnerHTML={ createMarkup(item.title) }/>
                        <p dangerouslySetInnerHTML={ createMarkup(item.description) }/>
                    </>
                }) }
            </div>
        </div>
    );
};
